import { Paper, Dialog, Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
interface AlertInput {
  severity: any;
  message: string;
  open: boolean;
  handleClose: any;
}
const AlertDialog = (props: AlertInput) => {
 // console.log("🚀 ~ file: AlertDialog.tsx ~ line 10 ~ AlertDialog ~ open", props.open);
  return (
    <Paper>
      <Dialog
        open={props.open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <Alert
          severity={props.severity}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                props.handleClose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2, width: 600 }}
        >
          {props.message}
        </Alert>
      </Dialog>
    </Paper>
  );
};

export default AlertDialog;
